import { render, staticRenderFns } from "./falcon-water-pro-6.vue?vue&type=template&id=3e3a07b8&"
import script from "./falcon-water-pro-6.vue?vue&type=script&lang=js&"
export * from "./falcon-water-pro-6.vue?vue&type=script&lang=js&"
import style0 from "./falcon-water-pro-6.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLayout,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QImg})
